import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { CompanyAndTenantInfo } from '../../../core/models/company-and-tenant-info';

@Component({
  selector: 'app-remove-realm-dialog',
  imports: [
    FormsModule,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
  ],
  templateUrl: './remove-realm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './remove-realm-dialog.component.scss',
})
export class RemoveRealmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CompanyAndTenantInfo,
    private readonly dialogRef: MatDialogRef<RemoveRealmDialogComponent>,
  ) {}

  removeRealmClicked() {
    this.dialogRef.close(true);
  }
}
